module.exports = {
          srcSet: __webpack_public_path__ + "public/aa2ca2a374fcdfcaafee1e8a067d3e45-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/aa2ca2a374fcdfcaafee1e8a067d3e45-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/aa2ca2a374fcdfcaafee1e8a067d3e45-80.png",
          toString:function(){return __webpack_public_path__ + "public/aa2ca2a374fcdfcaafee1e8a067d3e45-80.png"},
          
          width: 80,
          height: 80
        }